{
 "provinces": {
  "5km": {
   "id": "5km",
   "name": "Five Kings Mountains",
   "type": "inland",
   "sc": true,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "car",
    "dru",
    "gal",
    "isg",
    "kyo",
    "ore"
   ],
   "fleetAdj": {}
  },
  "abs": {
   "id": "abs",
   "name": "Absalom",
   "type": "coastal",
   "sc": true,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "eas",
     "jag",
     "sar",
     "stb",
     "swe"
    ]
   }
  },
  "aby": {
   "id": "aby",
   "name": "Aspo Bay",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "arf",
     "aug",
     "eas",
     "mid",
     "ost"
    ]
   }
  },
  "alm": {
   "id": "alm",
   "name": "Almas",
   "type": "coastal",
   "sc": true,
   "home": "ANDORAN",
   "coasts": [],
   "armyAdj": [
    "aug",
    "car",
    "ore"
   ],
   "fleetAdj": {
    "": [
     "eas",
     "stb"
    ]
   }
  },
  "an": {
   "id": "an",
   "name": "An",
   "type": "coastal",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "ktp",
    "lam",
    "mwx",
    "shi",
    "sot",
    "tot"
   ],
   "fleetAdj": {
    "": [
     "sco",
     "sot"
    ]
   }
  },
  "arf": {
   "id": "arf",
   "name": "Arthfell",
   "type": "coastal",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "aug",
    "isg",
    "ore",
    "ost",
    "wsp"
   ],
   "fleetAdj": {
    "": [
     "aby"
    ]
   }
  },
  "asp": {
   "id": "asp",
   "name": "Aspenthar",
   "type": "coastal",
   "sc": true,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "lam",
    "mer",
    "shi"
   ],
   "fleetAdj": {
    "": [
     "eas",
     "mer",
     "mid"
    ]
   }
  },
  "aug": {
   "id": "aug",
   "name": "Augustana",
   "type": "coastal",
   "sc": true,
   "home": "ANDORAN",
   "coasts": [],
   "armyAdj": [
    "alm",
    "arf",
    "ore"
   ],
   "fleetAdj": {
    "": [
     "aby",
     "eas"
    ]
   }
  },
  "azi": {
   "id": "azi",
   "name": "Azir",
   "type": "coastal",
   "sc": true,
   "home": "RAHADOUM",
   "coasts": [],
   "armyAdj": [
    "bot",
    "kha",
    "man"
   ],
   "fleetAdj": {
    "": [
     "kha",
     "mao"
    ]
   }
  },
  "bot": {
   "id": "bot",
   "name": "Botosani",
   "type": "coastal",
   "sc": true,
   "home": "RAHADOUM",
   "coasts": [],
   "armyAdj": [
    "azi",
    "hal",
    "man",
    "sod"
   ],
   "fleetAdj": {
    "": [
     "mao"
    ]
   }
  },
  "car": {
   "id": "car",
   "name": "Carpenden",
   "type": "coastal",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "5km",
    "alm",
    "cas",
    "gal",
    "ore",
    "ver"
   ],
   "fleetAdj": {
    "": [
     "cas",
     "stb"
    ]
   }
  },
  "cas": {
   "id": "cas",
   "name": "Cassomir",
   "type": "coastal",
   "sc": true,
   "home": "TALDOR",
   "coasts": [],
   "armyAdj": [
    "car",
    "mah",
    "opp",
    "ver"
   ],
   "fleetAdj": {
    "": [
     "car",
     "jag",
     "stb"
    ]
   }
  },
  "con": {
   "id": "con",
   "name": "Conqueror's Bay",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "kor",
     "nis",
     "rav/nc",
     "stm",
     "vyr"
    ]
   }
  },
  "cor": {
   "id": "cor",
   "name": "Corentyn",
   "type": "coastal",
   "sc": true,
   "home": "CHELIAX",
   "coasts": [
    "ec",
    "wc"
   ],
   "armyAdj": [
    "ego",
    "kha",
    "pez",
    "wcr"
   ],
   "fleetAdj": {
    "ec": [
     "kha",
     "wcr",
     "wes"
    ],
    "wc": [
     "kha",
     "mao",
     "pez"
    ]
   }
  },
  "dru": {
   "id": "dru",
   "name": "Druma",
   "type": "inland",
   "sc": true,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "5km",
    "isg",
    "kyo",
    "mol"
   ],
   "fleetAdj": {}
  },
  "eas": {
   "id": "eas",
   "name": "Eastern Inner Sea",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "abs",
     "aby",
     "alm",
     "asp",
     "aug",
     "mid",
     "shi",
     "stb",
     "swe"
    ]
   }
  },
  "ego": {
   "id": "ego",
   "name": "Egorian",
   "type": "inland",
   "sc": true,
   "home": "CHELIAX",
   "coasts": [],
   "armyAdj": [
    "cor",
    "men",
    "pez",
    "wcr",
    "wsp"
   ],
   "fleetAdj": {}
  },
  "fvr": {
   "id": "fvr",
   "name": "Fever Sea",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "med",
     "sao",
     "sod"
    ]
   }
  },
  "gal": {
   "id": "gal",
   "name": "Galt",
   "type": "inland",
   "sc": true,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "5km",
    "car",
    "kyo",
    "mah",
    "ver",
    "wsl"
   ],
   "fleetAdj": {}
  },
  "gem": {
   "id": "gem",
   "name": "Gemcrown Bay",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "sol",
     "wcr",
     "wes",
     "wsp",
     "wyv"
    ]
   }
  },
  "hal": {
   "id": "hal",
   "name": "Haldun",
   "type": "inland",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "bot",
    "lam",
    "man",
    "mwx",
    "sod"
   ],
   "fleetAdj": {}
  },
  "isg": {
   "id": "isg",
   "name": "Isger",
   "type": "inland",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "5km",
    "arf",
    "dru",
    "men",
    "mol",
    "ore",
    "wsp"
   ],
   "fleetAdj": {}
  },
  "jag": {
   "id": "jag",
   "name": "Jagged Saw",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "abs",
     "cas",
     "opp",
     "sar",
     "stb"
    ]
   }
  },
  "jal": {
   "id": "jal",
   "name": "Jalmeray",
   "type": "coastal",
   "sc": true,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "moo",
     "soo"
    ]
   }
  },
  "kat": {
   "id": "kat",
   "name": "Katheer",
   "type": "coastal",
   "sc": true,
   "home": "QADIRA",
   "coasts": [],
   "armyAdj": [
    "ktz",
    "sha",
    "whm"
   ],
   "fleetAdj": {
    "": [
     "sar"
    ]
   }
  },
  "kha": {
   "id": "kha",
   "name": "Khari",
   "type": "coastal",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "azi",
    "cor",
    "man"
   ],
   "fleetAdj": {
    "": [
     "azi",
     "cor/ec",
     "cor/wc",
     "man",
     "mao",
     "wes"
    ]
   }
  },
  "kor": {
   "id": "kor",
   "name": "Korvosa",
   "type": "coastal",
   "sc": true,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "nir",
    "nis",
    "pan"
   ],
   "fleetAdj": {
    "": [
     "con",
     "nis",
     "stm"
    ]
   }
  },
  "ktp": {
   "id": "ktp",
   "name": "Katapesh",
   "type": "coastal",
   "sc": true,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "an",
    "mwx",
    "nex"
   ],
   "fleetAdj": {
    "": [
     "moo",
     "sco"
    ]
   }
  },
  "ktz": {
   "id": "ktz",
   "name": "Ketz Desert",
   "type": "coastal",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "kat",
    "sed",
    "sha"
   ],
   "fleetAdj": {
    "": [
     "noo",
     "sar"
    ]
   }
  },
  "kyo": {
   "id": "kyo",
   "name": "Kyonin",
   "type": "inland",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "5km",
    "dru",
    "gal"
   ],
   "fleetAdj": {}
  },
  "lam": {
   "id": "lam",
   "name": "Lamsara",
   "type": "inland",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "an",
    "asp",
    "hal",
    "man",
    "mer",
    "mwx",
    "shi"
   ],
   "fleetAdj": {}
  },
  "mah": {
   "id": "mah",
   "name": "Maheto",
   "type": "inland",
   "sc": true,
   "home": "TALDOR",
   "coasts": [],
   "armyAdj": [
    "cas",
    "gal",
    "opp",
    "ver",
    "wsl"
   ],
   "fleetAdj": {}
  },
  "man": {
   "id": "man",
   "name": "Manaket",
   "type": "coastal",
   "sc": true,
   "home": "RAHADOUM",
   "coasts": [],
   "armyAdj": [
    "azi",
    "bot",
    "hal",
    "kha",
    "lam",
    "mer"
   ],
   "fleetAdj": {
    "": [
     "kha",
     "mer",
     "wes",
     "wyv"
    ]
   }
  },
  "mao": {
   "id": "mao",
   "name": "Mid-Arcadian Ocean",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "azi",
     "bot",
     "cor/wc",
     "kha",
     "med",
     "nao",
     "pez",
     "sao",
     "sod"
    ]
   }
  },
  "med": {
   "id": "med",
   "name": "Mediogalti Island",
   "type": "coastal",
   "sc": true,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "fvr",
     "mao",
     "sao"
    ]
   }
  },
  "men": {
   "id": "men",
   "name": "Menador",
   "type": "inland",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "ego",
    "isg",
    "mol",
    "pez",
    "rav",
    "rid",
    "usk",
    "wsp"
   ],
   "fleetAdj": {}
  },
  "mer": {
   "id": "mer",
   "name": "Merab",
   "type": "coastal",
   "sc": true,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "asp",
    "lam",
    "man"
   ],
   "fleetAdj": {
    "": [
     "asp",
     "man",
     "mid",
     "wyv"
    ]
   }
  },
  "mid": {
   "id": "mid",
   "name": "Mid-Inner Sea",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "aby",
     "asp",
     "eas",
     "mer",
     "ost",
     "sol",
     "wsp",
     "wyv"
    ]
   }
  },
  "mol": {
   "id": "mol",
   "name": "Molthune",
   "type": "inland",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "dru",
    "isg",
    "men",
    "nir",
    "pan",
    "rid"
   ],
   "fleetAdj": {}
  },
  "moo": {
   "id": "moo",
   "name": "Mid-Obari Ocean",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "jal",
     "ktp",
     "nex",
     "noo",
     "oke",
     "sco",
     "sed",
     "soo"
    ]
   }
  },
  "mwx": {
   "id": "mwx",
   "name": "Mwangi Expanse",
   "type": "inland",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "an",
    "hal",
    "ktp",
    "lam",
    "nex",
    "sod"
   ],
   "fleetAdj": {}
  },
  "nao": {
   "id": "nao",
   "name": "North Arcadian Ocean",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "mao",
     "pez",
     "rav/wc",
     "stm"
    ]
   }
  },
  "nex": {
   "id": "nex",
   "name": "Nex",
   "type": "coastal",
   "sc": true,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "ktp",
    "mwx"
   ],
   "fleetAdj": {
    "": [
     "moo",
     "soo"
    ]
   }
  },
  "nir": {
   "id": "nir",
   "name": "Nirmathas",
   "type": "inland",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "kor",
    "mol",
    "pan"
   ],
   "fleetAdj": {}
  },
  "nis": {
   "id": "nis",
   "name": "Nisroch",
   "type": "coastal",
   "sc": true,
   "home": "NIDAL",
   "coasts": [],
   "armyAdj": [
    "kor",
    "pan",
    "rav",
    "usk"
   ],
   "fleetAdj": {
    "": [
     "con",
     "kor",
     "rav/nc"
    ]
   }
  },
  "noo": {
   "id": "noo",
   "name": "North Obari Ocean",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "ktz",
     "moo",
     "oke",
     "sar",
     "sco",
     "sed"
    ]
   }
  },
  "oke": {
   "id": "oke",
   "name": "Okeno",
   "type": "coastal",
   "sc": true,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "moo",
     "noo",
     "sco"
    ]
   }
  },
  "opp": {
   "id": "opp",
   "name": "Oppara",
   "type": "coastal",
   "sc": true,
   "home": "TALDOR",
   "coasts": [],
   "armyAdj": [
    "cas",
    "mah",
    "whm",
    "wsl"
   ],
   "fleetAdj": {
    "": [
     "jag",
     "sar"
    ]
   }
  },
  "ore": {
   "id": "ore",
   "name": "Oregent",
   "type": "inland",
   "sc": true,
   "home": "ANDORAN",
   "coasts": [],
   "armyAdj": [
    "5km",
    "alm",
    "arf",
    "aug",
    "car",
    "isg"
   ],
   "fleetAdj": {}
  },
  "ost": {
   "id": "ost",
   "name": "Ostenso",
   "type": "coastal",
   "sc": true,
   "home": "CHELIAX",
   "coasts": [],
   "armyAdj": [
    "arf",
    "wsp"
   ],
   "fleetAdj": {
    "": [
     "aby",
     "mid"
    ]
   }
  },
  "pan": {
   "id": "pan",
   "name": "Pangolais",
   "type": "inland",
   "sc": true,
   "home": "NIDAL",
   "coasts": [],
   "armyAdj": [
    "kor",
    "mol",
    "nir",
    "nis",
    "rid",
    "usk"
   ],
   "fleetAdj": {}
  },
  "pez": {
   "id": "pez",
   "name": "Pezzack",
   "type": "coastal",
   "sc": true,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "cor",
    "ego",
    "men",
    "rav"
   ],
   "fleetAdj": {
    "": [
     "cor/wc",
     "mao",
     "nao",
     "rav/wc"
    ]
   }
  },
  "rav": {
   "id": "rav",
   "name": "Ravounel",
   "type": "coastal",
   "sc": false,
   "home": null,
   "coasts": [
    "nc",
    "wc"
   ],
   "armyAdj": [
    "men",
    "nis",
    "pez",
    "usk",
    "vyr"
   ],
   "fleetAdj": {
    "nc": [
     "con",
     "nis",
     "vyr"
    ],
    "wc": [
     "nao",
     "pez",
     "stm",
     "vyr"
    ]
   }
  },
  "rid": {
   "id": "rid",
   "name": "Ridwan",
   "type": "inland",
   "sc": true,
   "home": "NIDAL",
   "coasts": [],
   "armyAdj": [
    "men",
    "mol",
    "pan",
    "usk"
   ],
   "fleetAdj": {}
  },
  "sao": {
   "id": "sao",
   "name": "South Arcadian Ocean",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "fvr",
     "mao",
     "med"
    ]
   }
  },
  "sar": {
   "id": "sar",
   "name": "Saray Coast",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "abs",
     "jag",
     "kat",
     "ktz",
     "noo",
     "opp",
     "sco",
     "swe",
     "whm"
    ]
   }
  },
  "sco": {
   "id": "sco",
   "name": "Scorpion Coast",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "an",
     "ktp",
     "moo",
     "noo",
     "oke",
     "sar",
     "sot",
     "swe"
    ]
   }
  },
  "sed": {
   "id": "sed",
   "name": "Sedeq",
   "type": "coastal",
   "sc": true,
   "home": "QADIRA",
   "coasts": [],
   "armyAdj": [
    "ktz",
    "sha"
   ],
   "fleetAdj": {
    "": [
     "moo",
     "noo"
    ]
   }
  },
  "sha": {
   "id": "sha",
   "name": "Shamara",
   "type": "inland",
   "sc": true,
   "home": "QADIRA",
   "coasts": [],
   "armyAdj": [
    "kat",
    "ktz",
    "sed",
    "whm",
    "wsl"
   ],
   "fleetAdj": {}
  },
  "shi": {
   "id": "shi",
   "name": "Shiman-Sekh",
   "type": "coastal",
   "sc": true,
   "home": "OSIRION",
   "coasts": [],
   "armyAdj": [
    "an",
    "asp",
    "lam",
    "tot"
   ],
   "fleetAdj": {
    "": [
     "eas",
     "swe"
    ]
   }
  },
  "sod": {
   "id": "sod",
   "name": "Sodden Lands",
   "type": "coastal",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "bot",
    "hal",
    "mwx"
   ],
   "fleetAdj": {
    "": [
     "fvr",
     "mao"
    ]
   }
  },
  "sol": {
   "id": "sol",
   "name": "Bay of Solva",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "gem",
     "mid",
     "wsp",
     "wyv"
    ]
   }
  },
  "soo": {
   "id": "soo",
   "name": "South Obari Ocean",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "jal",
     "moo",
     "nex"
    ]
   }
  },
  "sot": {
   "id": "sot",
   "name": "Sothis",
   "type": "coastal",
   "sc": true,
   "home": "OSIRION",
   "coasts": [],
   "armyAdj": [
    "an",
    "tot"
   ],
   "fleetAdj": {
    "": [
     "an",
     "sco",
     "swe"
    ]
   }
  },
  "stb": {
   "id": "stb",
   "name": "Star Bay",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "abs",
     "alm",
     "car",
     "cas",
     "eas",
     "jag"
    ]
   }
  },
  "stm": {
   "id": "stm",
   "name": "Steaming Sea",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "con",
     "kor",
     "nao",
     "rav/wc",
     "vyr"
    ]
   }
  },
  "swe": {
   "id": "swe",
   "name": "Swells of Gozreh",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "abs",
     "eas",
     "sar",
     "sco",
     "shi",
     "sot",
     "tot"
    ]
   }
  },
  "tot": {
   "id": "tot",
   "name": "Totra",
   "type": "coastal",
   "sc": true,
   "home": "OSIRION",
   "coasts": [],
   "armyAdj": [
    "an",
    "shi",
    "sot"
   ],
   "fleetAdj": {
    "": [
     "swe"
    ]
   }
  },
  "usk": {
   "id": "usk",
   "name": "Uskwood",
   "type": "inland",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "men",
    "nis",
    "pan",
    "rav",
    "rid"
   ],
   "fleetAdj": {}
  },
  "ver": {
   "id": "ver",
   "name": "Verduran",
   "type": "inland",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "car",
    "cas",
    "gal",
    "mah"
   ],
   "fleetAdj": {}
  },
  "vyr": {
   "id": "vyr",
   "name": "Vyre",
   "type": "coastal",
   "sc": true,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "rav"
   ],
   "fleetAdj": {
    "": [
     "con",
     "rav/nc",
     "rav/wc",
     "stm"
    ]
   }
  },
  "wcr": {
   "id": "wcr",
   "name": "Westcrown",
   "type": "coastal",
   "sc": true,
   "home": "CHELIAX",
   "coasts": [],
   "armyAdj": [
    "cor",
    "ego",
    "wsp"
   ],
   "fleetAdj": {
    "": [
     "cor/ec",
     "gem",
     "wes"
    ]
   }
  },
  "wes": {
   "id": "wes",
   "name": "Western Inner Sea",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "cor/ec",
     "gem",
     "kha",
     "man",
     "wcr",
     "wyv"
    ]
   }
  },
  "whm": {
   "id": "whm",
   "name": "Whitemarch",
   "type": "coastal",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "kat",
    "opp",
    "sha",
    "wsl"
   ],
   "fleetAdj": {
    "": [
     "sar"
    ]
   }
  },
  "wsl": {
   "id": "wsl",
   "name": "Whistling Plains",
   "type": "inland",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "gal",
    "mah",
    "opp",
    "sha",
    "whm"
   ],
   "fleetAdj": {}
  },
  "wsp": {
   "id": "wsp",
   "name": "Whisperwood",
   "type": "coastal",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [
    "arf",
    "ego",
    "isg",
    "men",
    "ost",
    "wcr"
   ],
   "fleetAdj": {
    "": [
     "gem",
     "mid",
     "sol"
    ]
   }
  },
  "wyv": {
   "id": "wyv",
   "name": "Wyvern's Roost",
   "type": "sea",
   "sc": false,
   "home": null,
   "coasts": [],
   "armyAdj": [],
   "fleetAdj": {
    "": [
     "gem",
     "man",
     "mer",
     "mid",
     "sol",
     "wes"
    ]
   }
  }
 },
 "lifeAdjacency": {
  "5km": [
   "car",
   "dru",
   "gal",
   "isg",
   "kyo",
   "ore"
  ],
  "abs": [
   "eas",
   "jag",
   "sar",
   "stb",
   "swe"
  ],
  "aby": [
   "arf",
   "aug",
   "eas",
   "mid",
   "ost"
  ],
  "alm": [
   "aug",
   "car",
   "eas",
   "ore",
   "stb"
  ],
  "an": [
   "ktp",
   "lam",
   "mwx",
   "sco",
   "shi",
   "sot",
   "tot"
  ],
  "arf": [
   "aby",
   "aug",
   "isg",
   "ore",
   "ost",
   "wsp"
  ],
  "asp": [
   "eas",
   "lam",
   "mer",
   "mid",
   "shi"
  ],
  "aug": [
   "aby",
   "alm",
   "arf",
   "eas",
   "ore"
  ],
  "azi": [
   "bot",
   "kha",
   "man",
   "mao"
  ],
  "bot": [
   "azi",
   "hal",
   "man",
   "mao",
   "sod"
  ],
  "car": [
   "5km",
   "alm",
   "cas",
   "gal",
   "ore",
   "stb",
   "ver"
  ],
  "cas": [
   "car",
   "jag",
   "mah",
   "opp",
   "stb",
   "ver"
  ],
  "con": [
   "kor",
   "nis",
   "rav",
   "stm",
   "vyr"
  ],
  "cor": [
   "ego",
   "kha",
   "mao",
   "pez",
   "wcr",
   "wes"
  ],
  "dru": [
   "5km",
   "isg",
   "kyo",
   "mol"
  ],
  "eas": [
   "abs",
   "aby",
   "alm",
   "asp",
   "aug",
   "mid",
   "shi",
   "stb",
   "swe"
  ],
  "ego": [
   "cor",
   "men",
   "pez",
   "wcr",
   "wsp"
  ],
  "fvr": [
   "med",
   "sao",
   "sod"
  ],
  "gal": [
   "5km",
   "car",
   "kyo",
   "mah",
   "ver",
   "wsl"
  ],
  "gem": [
   "sol",
   "wcr",
   "wes",
   "wsp",
   "wyv"
  ],
  "hal": [
   "bot",
   "lam",
   "man",
   "mwx",
   "sod"
  ],
  "isg": [
   "5km",
   "arf",
   "dru",
   "men",
   "mol",
   "ore",
   "wsp"
  ],
  "jag": [
   "abs",
   "cas",
   "opp",
   "sar",
   "stb"
  ],
  "jal": [
   "moo",
   "soo"
  ],
  "kat": [
   "ktz",
   "sar",
   "sha",
   "whm"
  ],
  "kha": [
   "azi",
   "cor",
   "man",
   "mao",
   "wes"
  ],
  "kor": [
   "con",
   "nir",
   "nis",
   "pan",
   "stm"
  ],
  "ktp": [
   "an",
   "moo",
   "mwx",
   "nex",
   "sco"
  ],
  "ktz": [
   "kat",
   "noo",
   "sar",
   "sed",
   "sha"
  ],
  "kyo": [
   "5km",
   "dru",
   "gal"
  ],
  "lam": [
   "an",
   "asp",
   "hal",
   "man",
   "mer",
   "mwx",
   "shi"
  ],
  "mah": [
   "cas",
   "gal",
   "opp",
   "ver",
   "wsl"
  ],
  "man": [
   "azi",
   "bot",
   "hal",
   "kha",
   "lam",
   "mer",
   "wes",
   "wyv"
  ],
  "mao": [
   "azi",
   "bot",
   "cor",
   "kha",
   "med",
   "nao",
   "pez",
   "sao",
   "sod"
  ],
  "med": [
   "fvr",
   "mao",
   "sao"
  ],
  "men": [
   "ego",
   "isg",
   "mol",
   "pez",
   "rav",
   "rid",
   "usk",
   "wsp"
  ],
  "mer": [
   "asp",
   "lam",
   "man",
   "mid",
   "wyv"
  ],
  "mid": [
   "aby",
   "asp",
   "eas",
   "mer",
   "ost",
   "sol",
   "wsp",
   "wyv"
  ],
  "mol": [
   "dru",
   "isg",
   "men",
   "nir",
   "pan",
   "rid"
  ],
  "moo": [
   "jal",
   "ktp",
   "nex",
   "noo",
   "oke",
   "sco",
   "sed",
   "soo"
  ],
  "mwx": [
   "an",
   "hal",
   "ktp",
   "lam",
   "nex",
   "sod"
  ],
  "nao": [
   "mao",
   "pez",
   "rav",
   "stm"
  ],
  "nex": [
   "ktp",
   "moo",
   "mwx",
   "soo"
  ],
  "nir": [
   "kor",
   "mol",
   "pan"
  ],
  "nis": [
   "con",
   "kor",
   "pan",
   "rav",
   "usk"
  ],
  "noo": [
   "ktz",
   "moo",
   "oke",
   "sar",
   "sco",
   "sed"
  ],
  "oke": [
   "moo",
   "noo",
   "sco"
  ],
  "opp": [
   "cas",
   "jag",
   "mah",
   "sar",
   "whm",
   "wsl"
  ],
  "ore": [
   "5km",
   "alm",
   "arf",
   "aug",
   "car",
   "isg"
  ],
  "ost": [
   "aby",
   "arf",
   "mid",
   "wsp"
  ],
  "pan": [
   "kor",
   "mol",
   "nir",
   "nis",
   "rid",
   "usk"
  ],
  "pez": [
   "cor",
   "ego",
   "mao",
   "men",
   "nao",
   "rav"
  ],
  "rav": [
   "con",
   "men",
   "nao",
   "nis",
   "pez",
   "stm",
   "usk",
   "vyr"
  ],
  "rid": [
   "men",
   "mol",
   "pan",
   "usk"
  ],
  "sao": [
   "fvr",
   "mao",
   "med"
  ],
  "sar": [
   "abs",
   "jag",
   "kat",
   "ktz",
   "noo",
   "opp",
   "sco",
   "swe",
   "whm"
  ],
  "sco": [
   "an",
   "ktp",
   "moo",
   "noo",
   "oke",
   "sar",
   "sot",
   "swe"
  ],
  "sed": [
   "ktz",
   "moo",
   "noo",
   "sha"
  ],
  "sha": [
   "kat",
   "ktz",
   "sed",
   "whm",
   "wsl"
  ],
  "shi": [
   "an",
   "asp",
   "eas",
   "lam",
   "swe",
   "tot"
  ],
  "sod": [
   "bot",
   "fvr",
   "hal",
   "mao",
   "mwx"
  ],
  "sol": [
   "gem",
   "mid",
   "wsp",
   "wyv"
  ],
  "soo": [
   "jal",
   "moo",
   "nex"
  ],
  "sot": [
   "an",
   "sco",
   "swe",
   "tot"
  ],
  "stb": [
   "abs",
   "alm",
   "car",
   "cas",
   "eas",
   "jag"
  ],
  "stm": [
   "con",
   "kor",
   "nao",
   "rav",
   "vyr"
  ],
  "swe": [
   "abs",
   "eas",
   "sar",
   "sco",
   "shi",
   "sot",
   "tot"
  ],
  "tot": [
   "an",
   "shi",
   "sot",
   "swe"
  ],
  "usk": [
   "men",
   "nis",
   "pan",
   "rav",
   "rid"
  ],
  "ver": [
   "car",
   "cas",
   "gal",
   "mah"
  ],
  "vyr": [
   "con",
   "rav",
   "stm"
  ],
  "wcr": [
   "cor",
   "ego",
   "gem",
   "wes",
   "wsp"
  ],
  "wes": [
   "cor",
   "gem",
   "kha",
   "man",
   "wcr",
   "wyv"
  ],
  "whm": [
   "kat",
   "opp",
   "sar",
   "sha",
   "wsl"
  ],
  "wsl": [
   "gal",
   "mah",
   "opp",
   "sha",
   "whm"
  ],
  "wsp": [
   "arf",
   "ego",
   "gem",
   "isg",
   "men",
   "mid",
   "ost",
   "sol",
   "wcr"
  ],
  "wyv": [
   "gem",
   "man",
   "mer",
   "mid",
   "sol",
   "wes"
  ]
 },
 "startingUnits": [
  {
   "power": "CHELIAX",
   "type": "A",
   "loc": "ego"
  },
  {
   "power": "CHELIAX",
   "type": "F",
   "loc": "wcr"
  },
  {
   "power": "CHELIAX",
   "type": "F",
   "loc": "cor/wc"
  },
  {
   "power": "CHELIAX",
   "type": "F",
   "loc": "ost"
  },
  {
   "power": "NIDAL",
   "type": "A",
   "loc": "pan"
  },
  {
   "power": "NIDAL",
   "type": "A",
   "loc": "rid"
  },
  {
   "power": "NIDAL",
   "type": "F",
   "loc": "nis"
  },
  {
   "power": "ANDORAN",
   "type": "A",
   "loc": "ore"
  },
  {
   "power": "ANDORAN",
   "type": "A",
   "loc": "alm"
  },
  {
   "power": "ANDORAN",
   "type": "F",
   "loc": "aug"
  },
  {
   "power": "TALDOR",
   "type": "A",
   "loc": "mah"
  },
  {
   "power": "TALDOR",
   "type": "F",
   "loc": "opp"
  },
  {
   "power": "TALDOR",
   "type": "F",
   "loc": "cas"
  },
  {
   "power": "QADIRA",
   "type": "A",
   "loc": "sha"
  },
  {
   "power": "QADIRA",
   "type": "F",
   "loc": "sed"
  },
  {
   "power": "QADIRA",
   "type": "F",
   "loc": "kat"
  },
  {
   "power": "OSIRION",
   "type": "A",
   "loc": "sot"
  },
  {
   "power": "OSIRION",
   "type": "A",
   "loc": "shi"
  },
  {
   "power": "OSIRION",
   "type": "F",
   "loc": "tot"
  },
  {
   "power": "RAHADOUM",
   "type": "A",
   "loc": "azi"
  },
  {
   "power": "RAHADOUM",
   "type": "F",
   "loc": "man"
  },
  {
   "power": "RAHADOUM",
   "type": "F",
   "loc": "bot"
  }
 ],
 "startingCenters": {
  "ANDORAN": [
   "alm",
   "aug",
   "ore"
  ],
  "CHELIAX": [
   "cor",
   "ego",
   "ost",
   "wcr"
  ],
  "NIDAL": [
   "nis",
   "pan",
   "rid"
  ],
  "OSIRION": [
   "shi",
   "sot",
   "tot"
  ],
  "QADIRA": [
   "kat",
   "sed",
   "sha"
  ],
  "RAHADOUM": [
   "azi",
   "bot",
   "man"
  ],
  "TALDOR": [
   "cas",
   "mah",
   "opp"
  ]
 },
 "aliases": {
  "5km": [
   "5km",
   "five kings mountains",
   "highelm"
  ],
  "abs": [
   "abs",
   "absalom"
  ],
  "aby": [
   "aby",
   "aspo bay"
  ],
  "alm": [
   "alm",
   "almas"
  ],
  "an": [
   "an"
  ],
  "arf": [
   "arf",
   "arthfell"
  ],
  "asp": [
   "asp",
   "aspenthar"
  ],
  "aug": [
   "aug",
   "augustana"
  ],
  "azi": [
   "azi",
   "azir"
  ],
  "bot": [
   "bot",
   "botosani"
  ],
  "car": [
   "car",
   "carpenden"
  ],
  "cas": [
   "cas",
   "cassomir"
  ],
  "con": [
   "con",
   "conqueror's bay",
   "conquerors bay"
  ],
  "cor": [
   "cor",
   "corentyn"
  ],
  "cor/ec": [
   "cor/ec",
   "corentyn (east coast)"
  ],
  "cor/wc": [
   "cor/wc",
   "corentyn (west coast)"
  ],
  "dru": [
   "dru",
   "druma",
   "kerse"
  ],
  "eas": [
   "eas",
   "eastern inner sea"
  ],
  "ego": [
   "ego",
   "egorian"
  ],
  "fvr": [
   "fever sea",
   "fvr"
  ],
  "gal": [
   "gal",
   "galt",
   "isarn"
  ],
  "gem": [
   "gem",
   "gemcrown bay"
  ],
  "hal": [
   "hal",
   "haldun"
  ],
  "isg": [
   "isg",
   "isger"
  ],
  "jag": [
   "jag",
   "jagged saw"
  ],
  "jal": [
   "jal",
   "jalmeray"
  ],
  "kat": [
   "kat",
   "katheer"
  ],
  "kha": [
   "kha",
   "khari"
  ],
  "kor": [
   "kor",
   "korvosa"
  ],
  "ktp": [
   "katapesh",
   "ktp"
  ],
  "ktz": [
   "ketz desert",
   "ktz"
  ],
  "kyo": [
   "iadara",
   "kyo",
   "kyonin"
  ],
  "lam": [
   "lam",
   "lamsara"
  ],
  "mah": [
   "mah",
   "maheto"
  ],
  "man": [
   "man",
   "manaket"
  ],
  "mao": [
   "mao",
   "mid arcadian ocean",
   "mid-arcadian ocean"
  ],
  "med": [
   "med",
   "mediogalti island"
  ],
  "men": [
   "men",
   "menador"
  ],
  "mer": [
   "mer",
   "merab"
  ],
  "mid": [
   "mid",
   "mid inner sea",
   "mid-inner sea"
  ],
  "mol": [
   "canorate",
   "mol",
   "molthune"
  ],
  "moo": [
   "mid obari ocean",
   "mid-obari ocean",
   "moo"
  ],
  "mwx": [
   "mwangi expanse",
   "mwx"
  ],
  "nao": [
   "nao",
   "north arcadian ocean"
  ],
  "nex": [
   "nex"
  ],
  "nir": [
   "nir",
   "nirmathas"
  ],
  "nis": [
   "nis",
   "nisroch"
  ],
  "noo": [
   "noo",
   "north obari ocean"
  ],
  "oke": [
   "oke",
   "okeno"
  ],
  "opp": [
   "opp",
   "oppara"
  ],
  "ore": [
   "ore",
   "oregent"
  ],
  "ost": [
   "ost",
   "ostenso"
  ],
  "pan": [
   "pan",
   "pangolais"
  ],
  "pez": [
   "pez",
   "pezzack"
  ],
  "rav": [
   "rav",
   "ravounel"
  ],
  "rav/nc": [
   "rav/nc",
   "ravounel (north coast)"
  ],
  "rav/wc": [
   "rav/wc",
   "ravounel (west coast)"
  ],
  "rid": [
   "rid",
   "ridwan"
  ],
  "sao": [
   "sao",
   "south arcadian ocean"
  ],
  "sar": [
   "sar",
   "saray coast"
  ],
  "sco": [
   "sco",
   "scorpion coast"
  ],
  "sed": [
   "sed",
   "sedeq"
  ],
  "sha": [
   "sha",
   "shamara"
  ],
  "shi": [
   "shi",
   "shiman sekh",
   "shiman-sekh"
  ],
  "sod": [
   "sod",
   "sodden lands"
  ],
  "sol": [
   "bay of solva",
   "sol"
  ],
  "soo": [
   "soo",
   "south obari ocean"
  ],
  "sot": [
   "sot",
   "sothis"
  ],
  "stb": [
   "star bay",
   "stb"
  ],
  "stm": [
   "steaming sea",
   "stm"
  ],
  "swe": [
   "swe",
   "swells of gozreh"
  ],
  "tot": [
   "tot",
   "totra"
  ],
  "usk": [
   "usk",
   "uskwood"
  ],
  "ver": [
   "ver",
   "verduran"
  ],
  "vyr": [
   "vyr",
   "vyre"
  ],
  "wcr": [
   "wcr",
   "westcrown"
  ],
  "wes": [
   "wes",
   "western inner sea"
  ],
  "whm": [
   "whitemarch",
   "whm"
  ],
  "wsl": [
   "whistling plains",
   "wsl"
  ],
  "wsp": [
   "whisperwood",
   "wsp"
  ],
  "wyv": [
   "wyv",
   "wyvern's roost",
   "wyverns roost"
  ]
 }
}
